<template>
  <div>
    <h6
      v-if="typeof VALUE == 'number'"
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
    >
      {{ currencyFormatter(VALUE) }}
    </h6>
    <h6
      v-else
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
    >
      {{ VALUE }}
    </h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: ""
    };
  },
  created() {
    this.VALUE = this.params.value;
  },
  methods: {
    currencyFormatter(currency) {
      var parfloat = parseFloat(currency);

      if (typeof currency == "undefined" || currency == null) return "";
      else {
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return "₺" + `${formatted}`;
      }
    }
  }
};
</script>
